import { useSingleton } from '@bydesign-ui/hooks';
import { Form } from '../../hooks/form';
export function useForm(options) {
  return useSingleton(function () {
    return new Form(options || {});
  });
}